import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertIconComponent } from './icon-alert.component';
import { CloseIconComponent } from './icon-close.component';
import { ValidIconComponent } from './icon-valid.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    AlertIconComponent,
    CloseIconComponent,
    ValidIconComponent,
  ],
  exports: [
    AlertIconComponent,
    CloseIconComponent,
    ValidIconComponent,
  ],
})
export class IconsModule { }
